<div class="view-component-title">{{'meli.variation.dataSearch'|translateTA}}</div>
<div class="content">
    <div class="data-list">
        <ng-container *ngFor="let cat of data | keyvalue | arrayFilter:'value':'null':false">
            <div class="data-card" (click)="select(cat)" *ngIf="canShow(cat)">
                <div class="data-selector">
                    <div class="field-name">{{cat.key}}</div>
                    <div class="field-value">{{cat.value}}</div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
